
















module.exports =
  name: 'transaction_repeat_options'
  props: ['transaction', 'mode']
  data: ->
    all_periods: require('models/transaction_periods.coffee')
  computed:
    planned_repeat_end_date:
      get: ->
        @transaction.planned_repeat_end_date ||= hm_date.addMonths_f(new Date, 1)
        hm_date.parse(@transaction.planned_repeat_end_date)
      set: (val) ->
        @transaction.planned_repeat_end_date = hm_date.format(val)
